import { render, staticRenderFns } from "./BBBPublishedFiles.vue?vue&type=template&id=b31cfb0a&"
import script from "./BBBPublishedFiles.vue?vue&type=script&lang=js&"
export * from "./BBBPublishedFiles.vue?vue&type=script&lang=js&"
import style0 from "./BBBPublishedFiles.vue?vue&type=style&index=0&id=b31cfb0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports